import { getStrings } from "@microsoft/shifts-experiences-shared";
import { Body1Strong, Button, Caption1, Flex, Image } from "@microsoft/shifts-ui-core";
import { observer } from "mobx-react";
import * as React from "react";
import emptyView from "sh-assets/images/empty-scheduling-rules.svg";

import { useEmptyConstraintsListStyles } from "./EmptyConstraintsList.styles";

/**
 * Renders the empty state for scheduling constraints with icon, text, and action button.
 * @param props The properties.
 * @returns The empty constraints list component.
 */
export const EmptyConstraintsList: React.FC<EmptyConstraintsListProps> = observer(props => {
    const { settingsButtonProps } = props;
    const styles = useEmptyConstraintsListStyles();

    return (
        <Flex className={styles.container}>
            <Flex className={styles.iconContainer}>
                <Image
                    src={emptyView}
                    alt=""
                    className={styles.icon}
                />
            </Flex>
            <Body1Strong>
                {getStrings("schedulingConstraints", "noSchedulingRulesEnabled")}
            </Body1Strong>
            <Caption1 className={styles.description}>
                {getStrings("schedulingConstraints", "enableRulesDescription")}
            </Caption1>
            <Button
                appearance="primary"
                className={styles.enableButton}
                {...settingsButtonProps}
            >
                {getStrings("schedulingConstraints", "enableSchedulingRules")}
            </Button>
        </Flex>
    );
});

/**
 * Props for the empty constraints list component.
 */
export interface EmptyConstraintsListProps {
    /**
     * Props for the settings button.
     */
    settingsButtonProps: {
        /**
         * Handler for button click.
         */
        onClick: () => void;
    };
}